// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__DoBK9","contentWrapper":"styles_contentWrapper___WdiO","content":"styles_content__JFgdg"};